// Support tickets / live chat → backend /support router.
import { api } from "./client";

// ── Reporter (tester / admin) ────────────────────────────────────────────────
export const createTicket = (data) => api.post("/support/ticket", data);
export const listMyTickets = () => api.get("/support/my-tickets");
export const getMyUnreadCount = () => api.get("/support/my-tickets/unread-count");
export const getMyTicket = (id) => api.get(`/support/${id}`);
export const listMyTicketMessages = (id) => api.get(`/support/${id}/messages`);
export const postMyTicketMessage = (id, body) =>
  api.post(`/support/${id}/messages`, { body });
export const reopenMyTicket = (id) => api.post(`/support/${id}/reopen`, {});
export const closeMyTicket = (id) => api.post(`/support/${id}/close`, {});

// ── SuperAdmin inbox ─────────────────────────────────────────────────────────
// Paged and searchable. Returns {tickets, total, limit, offset} — this used to
// be a bare list hard-capped at 200 with no way to search or reach older rows.
export const adminListTickets = (params) =>
  api.get("/support/admin/tickets", { params });
export const adminUnreadCount = () => api.get("/support/admin/unread-count");
export const adminGetTicket = (id) => api.get(`/support/admin/tickets/${id}`);
export const adminListMessages = (id) => api.get(`/support/admin/tickets/${id}/messages`);
export const adminPostMessage = (id, body) =>
  api.post(`/support/admin/tickets/${id}/messages`, { body });
export const adminSetStatus = (id, status) =>
  api.post(`/support/admin/tickets/${id}/status`, { status });

// Deletion. The backend decides who may delete what — these are the calls, not
// the authorization: a reporter may remove their OWN message on their own open
// ticket, a SuperAdmin may remove any message or a whole ticket.
export const deleteMyTicketMessage = (ticketId, messageId) =>
  api.del(`/support/${ticketId}/messages/${messageId}`);
export const adminDeleteMessage = (ticketId, messageId) =>
  api.del(`/support/admin/tickets/${ticketId}/messages/${messageId}`);
export const adminDeleteTicket = (id) => api.del(`/support/admin/tickets/${id}`);
